<script lang="ts" setup>
import type { AdditionalInsurances } from '~~/server/api/insurance/product'

// @ts-ignore
import { Splide, SplideSlide } from '@splidejs/vue-splide'

export interface InsuranceAdditionalProps {
    data: AdditionalInsurances
    headingLevel: HeadingLevel
}
const props = defineProps<InsuranceAdditionalProps>()
const sliderOptions = {
    gap: '3rem',
    drag: false,
    perPage: 4,
    breakpoints: {
        1200: {
            gap: '2rem',
            perPage: 3,
            arrows: true,
            pagination: true,
        },
        992: {
            drag: true,
        },
        768: {
            perPage: 1,
            fixedWidth: '90%',
            gap: '1rem',
        },
    },
}
const splideRef = ref<Splide>()
useFixSlideRoles(splideRef)
</script>

<template>
  <section data-cy="widget_insurance_additional">
    <Tracker :data="{ position: props.data.title }">
      <Box
        decor-position="top-left"
        color="green-light"
      >
        <BoxHeader
          :heading="props.data.title"
          :heading-level="props.headingLevel"
          :subtitle="props.data.subtitle"
        >
          <template #tag>
            <Tag
              size="small"
              text-color="black"
              background-color="green-2"
              class="text-uppercase"
            >
              {{ $t('Pripoistenia') }}
            </Tag>
          </template>
        </BoxHeader>
        <Slider
          ref="splideRef"
          :options="sliderOptions"
        >
          <SplideSlide
            v-for="(insurance, index) in props.data?.data"
            :key="`wai-${index}`"
            class="pt-2"
          >
            <WidgetInsuranceAdditionalItem
              :data="insurance"
              heading-level="h3"
            />
          </SplideSlide>
        </Slider>
      </Box>
      <IconsWrapper>
        <IconsSymbolAngleDown />
      </IconsWrapper>
    </Tracker>
  </section>
</template>
